import { useMemo } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, FolderOpen, Receipt, FileClock, Inbox, LogOut, Shield } from "lucide-react";

const NAV = [
  { to: "/portal", end: true, label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/portal/cases", label: "Cases", icon: FolderOpen, testid: "nav-cases" },
  { to: "/portal/intakes", label: "Intake Queue", icon: Inbox, testid: "nav-intakes", staff: true },
  { to: "/portal/invoices", label: "Invoices", icon: Receipt, testid: "nav-invoices" },
  { to: "/portal/audit", label: "Audit Log", icon: FileClock, testid: "nav-audit", staff: true },
];

export default function PortalShell() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const isStaff = user?.role === "admin" || user?.role === "staff_rn";
  const visibleNav = useMemo(() => NAV.filter((n) => !n.staff || isStaff), [isStaff]);
  return (
    <div className="min-h-screen bg-[#F8FAFC] flex">
      <aside className="w-64 bg-[#0A192F] text-slate-200 shrink-0 flex flex-col">
        <div className="p-6 border-b border-white/10">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 relative overflow-hidden border border-white">
              <div className="absolute inset-0 bg-[#0A192F]" /><div className="absolute bottom-0 left-0 right-0 h-1/3 bg-[#B91C1C]" />
              <Shield className="absolute inset-0 m-auto w-4 h-4 text-white" strokeWidth={2.2} />
            </div>
            <div><div className="font-serif font-bold text-white text-sm">Integrity First</div><div className="text-caption text-white/50 text-[9px]">RN PORTAL</div></div>
          </div>
        </div>
        <nav className="flex-1 py-6 px-3 space-y-1">
          {visibleNav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={n.testid}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 text-sm ${isActive ? "bg-white/10 text-white border-l-2 border-[#B91C1C]" : "text-slate-300 hover:bg-white/5 border-l-2 border-transparent"}`}>
              <n.icon className="w-4 h-4" />{n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10">
          <div className="text-caption text-white/50 mb-1">SIGNED IN</div>
          <div className="text-white text-sm truncate" data-testid="user-name">{user?.full_name}</div>
          <div className="text-slate-400 text-xs mb-3 uppercase tracking-widest font-mono">{user?.role}</div>
          <button onClick={() => { logout(); nav("/login"); }} data-testid="btn-logout" className="w-full inline-flex items-center gap-2 text-[11px] uppercase tracking-widest border border-white/20 px-3 py-2 hover:bg-white hover:text-[#0A192F]">
            <LogOut className="w-3.5 h-3.5" /> Sign Out
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-x-hidden">
        <div className="max-w-7xl mx-auto p-6 lg:p-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
